import { postFormData } from '../../02-tools/index'

export function ServiceUpdates() {

    const featuredUpdate = document.querySelector('.js-service-update-featured')
    const featuredContent = featuredUpdate?.querySelector('.js-service-update-featured-content')

    if (featuredContent) {
        postFormData(featuredUpdate.dataset.url)
            .then((json) => JSON.parse(json))
            .then((response) => {
                const data = response.data

                if (!data?.html) {
                    return
                }

                featuredContent.innerHTML = data.html
                featuredUpdate.classList.remove('c-service-update--featured-hidden')
            })
    }

    const updates = document.querySelector('.js-service-update')
    const content = updates?.querySelector('.js-page-list-container')
    const listing = updates?.querySelector('.js-service-update-listing')
    const loadMoreButton = updates?.querySelector('.js-page-list-btn-wrap')

    if (content) {
        postFormData(updates.dataset.url, {
            page: 1
        })
            .then((json) => JSON.parse(json))
            .then((response) => {
                const data = response.data

                if (!data?.html) {
                    return
                }

                content.innerHTML = data.html

                if (!data.pagination.hasNextPage && loadMoreButton) {
                    loadMoreButton.style.display = 'none'
                }

                listing.classList.remove('c-service-update__list-container--hidden')
            })
    }


}